import React from "react";
import Helmet from "react-helmet";

function SEO() {
    return (
        <Helmet>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />

            <meta name="robots" content="index,follow" />
            <meta name="googlebot" content="index,follow" />

            <link rel="canonical" href="https://pranavmene.tech/" />
            <meta name="description" content="Pranav Mene's Personal Website" />
            <meta name="image" content="https://pranavmene.tech/projectImages/dp.png" />
            <meta name="keywords" content="pranavmene .tech, Pranav Mene's portfolio, resume, pranavmene.tech" />
            <meta name="author" content="Pranav Mene" />
            <meta property="og:title" content="PranavMene.tech" />
            <meta property="og:url" content="https://pranavmene.tech/" />
            <meta property="og:description" content="Pranav Mene's Personal Website" />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://pranavmene.tech/projectImages/dp.png" />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@PranavMene11" />
            <meta name="twitter:creater" content="@PranavMene11" />
            <meta name="twitter:title" content="PranavMene.tech" />
            <meta name="twitter:description" content="Pranav Mene's Personal Website" />
            <meta name="twitter:image" content="https://pranavmene.tech/projectImages/dp.png" />

            <link rel="apple-touch-icon" sizes="76x76" href="/apple-touch-icon.png" />
            <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
            <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
            <link rel="manifest" href="/site.webmanifest" />
            <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
            <meta name="msapplication-TileColor" content="#da532c" />
            <meta name="theme-color" content="#ffffff" />

            <title>Portfolio | Pranav Mene 👋🏻</title>
        </Helmet>
    );
}

export default SEO